// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> phillips-pass
// Generated: 2026-10-05T18:31:59.257Z
// Counts: 1 design, 15 content, 21 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From sun-soaked afternoons by the pool to quiet mornings in the courtyard, every shared space at Phillips Pass is made for living well. Explore the amenities that turn an apartment into a true home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtful touches in every home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside to find the kind of details that make a house feel like home—rich cherry wood cabinetry, granite-style countertops, and energy-efficient appliances that work as hard as you do. With generous walk-in closets, a full-size washer and dryer, and a cozy fireplace, every space is finished to make daily life feel a little more effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed Around You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Shared spaces made for everyday living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>From poolside afternoons to a workout in the fitness center or coffee in the clubhouse, there's always somewhere to unwind just steps from your door. Gather friends around the grills in the picnic area or let the dog stretch their legs—at Phillips Pass, the community is built for the way you actually live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Connect</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From a resort-style pool to a fully equipped fitness center, every detail at Phillips Pass is designed for the way you want to live. Explore the standout features that make our Briar Village community feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from spacious one- and two-bedroom homes ranging from 708 to 1,148 square feet, each thoughtfully updated for modern living. Inside you'll find energy-efficient stainless steel appliances, cherry wood cabinetry, granite-style countertops, and full-size washers and dryers. Generous walk-in closets, private patios or balconies, and bright open layouts make every floor plan feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Phillips Pass brings resort-style living to Houston with a sparkling swimming pool, sundeck, and shaded grilling and picnic areas made for weekend gatherings. Stay active in the fully equipped fitness center, get things done in the resident clubhouse and work-from-home business center, and enjoy the ease of a gated community with package lockers. Beautifully landscaped courtyards and a playground round out a welcoming neighborhood you'll be proud to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Set in Houston's Energy Corridor near Terry Hershey and George Bush Parks, Phillips Pass offers spacious one- and two-bedroom homes from 708 to 1,148 square feet with upscale finishes like stainless steel appliances, custom cabinetry, quartz countertops, and full-size washers and dryers. Community amenities include a resort-style pool with sundeck, a fitness center, a resident clubhouse with a work-from-home business center, grilling stations, EV charging, and a pet-friendly bark park. Just off Eldridge Parkway between I-10 and the Westpark Tollway, you're minutes from major employers, top-rated shopping, and abundant green space. Schedule a tour today and see why residents love calling Phillips Pass home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Come home to Phillips Pass, where sunlit one- and two-bedroom apartments meet the ease of resort-style living on Houston's Eldridge Parkway. Spend afternoons by the sparkling pool, catch a workout in the fitness center, and unwind on your private patio as the Energy Corridor winds down. With Terry Hershey Park trails and everyday dining just minutes away, this is a place that feels like home the moment you arrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Phillips Pass, your furry family members are right at home. With beautifully landscaped grounds, winding courtyard paths, and nearby hiking trails, there's plenty of room for both you and your pets to stretch out and enjoy our welcoming Houston community.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-1350-777c-bd45-a6eb51ac0c98.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Cool off with a dip in our sparkling pool, then settle into a lounge chair and let the Houston afternoon melt away."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious and well-equipped fitness center with weight machines, free weights, and cardio equipment."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-eeee-720a-9bac-57d5fd08f22a.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Keep your routine close to home with cardio machines, weights, and strength equipment ready whenever inspiration strikes."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with a long desk, chairs, and a meeting table."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Clubhouse"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d07f5-ee2d-747f-b5c5-6706c4b2977b.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Work from home, host friends, or simply unwind in a stylish clubhouse and business center built for connection and focus alike."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool area with grills and seating"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Picnic Area with BBQ Grills"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-7b44-7310-a146-dc733c27cc5e.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Fire up the grills and gather outdoors for weekend cookouts and easy evenings under the Texas sky."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-303a-70ca-8b49-a09c79de3c38.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with sofa, coffee table, TV, and bar stools at kitchen counter."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449162905/019cfddd-0a62-71ed-9569-1335a72a6be6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a blue and white multifamily apartment building with balconies and manicured landscaping."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449162905/019cfddd-280b-7439-a1e7-b3273dc84388.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex courtyard with a walking path, lush greenery, and trees."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-60f5-7520-9913-5b30faeaf9e3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby with fireplace and seating area overlooking pool."
      }
    }
  },
  "featuredamenities.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Phillips Pass Apartment Homes outdoor swimming pool with lounge chairs and grilling area."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-4d27-70fe-9ec5-0c63f16b9569.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Soak up the Houston sun by our sparkling pool, where lounge chairs and a poolside grilling area set the scene for easy weekends and warm evenings."
      }
    }
  },
  "featuredamenities.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Treadmills and elliptical machines in a well-lit gym with large windows overlooking a pool and trees."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-a85b-761a-9449-901ed88c2b5c.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Stay on top of your goals in our light-filled fitness center, stocked with cardio machines and free weights and framed by views of the pool and greenery."
      }
    }
  },
  "featuredamenities.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby with fireplace and seating area overlooking pool."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Clubhouse"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-60f5-7520-9913-5b30faeaf9e3.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Gather, unwind, or get work done in our welcoming clubhouse, where a cozy fireplace and a built-in business center overlook the resort-style pool."
      }
    }
  },
  "featuredamenities.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex courtyard with a walking path, lush greenery, and trees."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Landscaped Courtyard"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-280b-7439-a1e7-b3273dc84388.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Step outside to winding paths, mature trees, and lush green spaces—a tranquil retreat that echoes the nearby nature trails of George Bush Park."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0a62-71ed-9569-1335a72a6be6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a blue and white multifamily apartment building with balconies and manicured landscaping."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-4d27-70fe-9ec5-0c63f16b9569.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Phillips Pass Apartment Homes outdoor swimming pool with lounge chairs and grilling area."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-60f5-7520-9913-5b30faeaf9e3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby with fireplace and seating area overlooking pool."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-280b-7439-a1e7-b3273dc84388.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex courtyard with a walking path, lush greenery, and trees."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0a62-71ed-9569-1335a72a6be6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a blue and white multifamily apartment building with balconies and manicured landscaping."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0a62-71ed-9569-1335a72a6be6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a blue and white multifamily apartment building with balconies and manicured landscaping."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-41cf-7309-a180-4b27da832b48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sectional sofa, coffee table, TV, and decorative items."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-239a-7709-9c71-23686dac9400.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, bedside tables, and a dresser."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-17fb-777e-8ae7-0caaf5f9580a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling blue swimming pool with steps and railings, surrounded by a paved patio and lush greenery. A white building with large windows and a blue building are visible in the background."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
